"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaults = getVaults;
exports.getSingleAssetVaults = getSingleAssetVaults;
exports.getDoubleAssetVaults = getDoubleAssetVaults;
const fetchUserVaults_js_1 = require("./sui-sdk/functions/fetchUserVaults.js");
async function getVaults(address) {
    const vaultsArr = await (0, fetchUserVaults_js_1.fetchUserVaults)(address);
    return vaultsArr;
}
async function getSingleAssetVaults(address) {
    const vaultsArr = [];
    const vaultsData = await (0, fetchUserVaults_js_1.fetchUserVaults)(address);
    vaultsData.forEach((v) => {
        const data = v;
        if (data.coinName)
            vaultsArr.push(data);
    });
    return vaultsArr;
}
async function getDoubleAssetVaults(address) {
    const vaultsArr = [];
    const vaultsData = await (0, fetchUserVaults_js_1.fetchUserVaults)(address);
    vaultsData.forEach((v) => {
        const data = v;
        if (data.coinNameA)
            vaultsArr.push(data);
    });
    return vaultsArr;
}
//# sourceMappingURL=getVaults.js.map